import React from 'react';
import PopconfirmComponent from 'antd/lib/popconfirm';

type Props = React.ComponentProps<typeof PopconfirmComponent>;

export default ({ children, ...props }: Props) => {
    return <PopconfirmComponent
        cancelText="Отмена"
        okText="Ок"
        icon={null}
        {...props}
    >
        {children}
    </PopconfirmComponent>
}
